@if (formGroup) {
  <form [formGroup]="formGroup" class="w-100">
    <create-demand-form-entry
      [control]="formGroup.controls.name"
      [label]="'Name' | translate"
      [hasError]="formGroup.controls?.name?.errors?.required"
      [errorMsg]="'Bitte tragen Sie einen Namen für den Artikel ein!' | translate"
      [required]="true"
      [maxStrLength]="nameMaxLength"
      >
      <input
        data-cy="ARTICLE_NAME_INPUT"
        formControlName="name"
        [maxlength]="nameMaxLength"
        [placeholder]="'Name' | translate"
        class="form-control"
        mark-required
        />
    </create-demand-form-entry>
    <create-demand-form-entry
      [control]="formGroup.controls.description"
      [saveSpaceForErrorMsg]="false"
      [maxStrLength]="descriptionMaxLength"
      [label]="'Beschreibung' | translate"
      >
      <textarea
        formControlName="description"
        [maxlength]="descriptionMaxLength"
        rows="5"
        [placeholder]="'Beschreibung' | translate"
        class="form-control"
      ></textarea>
    </create-demand-form-entry>
    <separator></separator>
    <div class="row mb-2">
      <div class="col">
        <mat-checkbox
          formControlName="customerProductNumberIsKnown"
          (change)="customerProductNumberIsKnownChanged($event.checked)"
          >
          {{ 'Artikelnummer ist bekannt' | translate }}
        </mat-checkbox>
      </div>
    </div>
    @if (formGroup.value.customerProductNumberIsKnown) {
      <create-demand-form-entry
        [control]="formGroup.controls.customerProductNumber"
        [required]="true"
        [hasError]="formGroup.controls?.customerProductNumber?.errors?.required"
        [errorMsg]="'Bitte geben Sie eine Artikelnummer ein' | translate"
        [maxStrLength]="articleNumberMaxLength"
        [label]="'Artikelnummer' | translate"
        >
        @if (formGroup.value['supplierArticleNumber'] === defaultArticleNumber && defaultArticleNumber) {
          <div
            class="alert alert-info mb-2"
            >
            {{
            'Die angegebene Artikelnummer ist die in den Einstellungen hinterlegte Dummy Artikelnummer' | translate
            }}
          </div>
        }
        <input
          formControlName="customerProductNumber"
          [placeholder]="'Artikelnummer eingeben' | translate"
          [maxlength]="articleNumberMaxLength"
          #customerProductNumberInput
          class="form-control"
          mark-required
          />
      </create-demand-form-entry>
    }
    <separator></separator>
    <create-demand-form-entry
      [control]="formGroup.controls.manufacturer"
      [label]="'Hersteller' | translate"
      [maxStrLength]="articleNumberMaxLength"
      >
      <input
        formControlName="manufacturer"
        [maxlength]="articleNumberMaxLength"
        [placeholder]="'Hersteller' | translate"
        class="form-control"
        />
    </create-demand-form-entry>
    <create-demand-form-entry
      [control]="formGroup.controls.manufacturerArticleNumber"
      [maxStrLength]="articleNumberMaxLength"
      [label]="'Artikelnummer (Hersteller)' | translate"
      >
      <input
        formControlName="manufacturerArticleNumber"
        [maxlength]="articleNumberMaxLength"
        [placeholder]="'Artikelnummer eingeben' | translate"
        class="form-control"
        />
    </create-demand-form-entry>
    <separator></separator>
    <create-demand-form-entry
      [control]="formGroup.controls.supplierArticleNumber"
      [maxStrLength]="articleNumberMaxLength"
      [label]="'Artikelnummer (Lieferant)' | translate"
      [hasError]="formGroup.controls?.supplierArticleNumber?.errors?.required"
      [errorMsg]="'Die Angabe einer Lieferanten Artikelnummer ist verpflichtend.' | translate"
      >
      <input
        data-cy="SUPPLIER_ARTICLE_NUMBER_INPUT"
        formControlName="supplierArticleNumber"
        [maxlength]="articleNumberMaxLength"
        [placeholder]="'Artikelnummer eingeben' | translate"
        class="form-control"
        />
    </create-demand-form-entry>
    <separator></separator>
    <create-demand-form-entry
      [control]="formGroup.controls.requestQuantity"
      [saveSpaceForErrorMsg]="false"
      [label]="'Bestellmenge' | translate"
      [hideInputGroupElements]="true"
      >
      <div class="col">
        <div class="row align-items-center">
          <div class="col-auto">
            <iim-decimal-input-v2
              formControlName="requestQuantity"
              [minimumValue]="0.01"
              [showPlusMinusBtn]="true"
              dataCyPrefix="QUANTITY"
            ></iim-decimal-input-v2>
          </div>
          <div class="col-auto">
            <unit-selection formControlName="requestUnit"></unit-selection>
          </div>
        </div>
      </div>
    </create-demand-form-entry>
    <create-demand-form-entry
      [hideInputGroupElements]="true"
      [saveSpaceForErrorMsg]="false"
      [control]="formGroup.controls.numberOfContentUnitsPerOrderUnit"
      [label]="'Inhaltsmenge' | translate"
      >
      <div class="col">
        <div class="row align-items-center">
          <div class="col-auto">
            <iim-decimal-input-v2
              formControlName="numberOfContentUnitsPerOrderUnit"
              [minimumValue]="0.01"
              [showPlusMinusBtn]="true"
              dataCyPrefix="NUMBER_OF_CONTENT_UNITS_PER_ORDER_UNIT"
            ></iim-decimal-input-v2>
          </div>
          <div class="col-auto">
            <unit-selection formControlName="contentUnit"></unit-selection>
          </div>
        </div>
      </div>
    </create-demand-form-entry>
  </form>
}
